import { PropsWithChildren, ReactNode } from 'react';

type DetailFieldProps = PropsWithChildren<{
  label: ReactNode;
  icon?: ReactNode;
}>;

export const DetailField = (props: DetailFieldProps) => {
  const { label, icon, children } = props;

  return (
    <div className="grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)] items-baseline gap-x-3">
      <span className="text-muted-foreground flex items-center gap-2 text-sm [&>svg]:size-4 [&>svg]:shrink-0 [&>svg]:self-center">
        {icon}
        {label}
      </span>
      <span className="text-foreground text-sm wrap-break-word whitespace-pre-wrap">
        {children}
      </span>
    </div>
  );
};
